<template>
  <div class="info-box static">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="overflow-y-auto px-2.5 flex-1"
    >
      <el-form-item label="状态">
        <el-switch
          v-model="state.model.status"
          active-text="启用"
          inactive-text="禁用"
          inline-prompt
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
      <el-form-item
        label="户名"
        prop="name"
        :rules="[{ required: true, message: '请输入户名', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <el-form-item
        label="账号"
        prop="account"
        :rules="[{ required: true, message: '请输入账号', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.account"></el-input>
      </el-form-item>
      <el-form-item
        label="开户行"
        prop="opening_bank"
        :rules="[{ required: true, message: '请输入开户行', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.opening_bank"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  bankAccount_detail,
  bankAccount_add,
  bankAccount_edit,
} from "@/http/bankAccount";
import { dic_getHotelRating } from "@/http/data";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      onLoadXj();
      if (props.id) {
        bankAccount_detail(props.id).then((res) => {
          if (res.status == 200) {
            const data = res.data?.data;
            state.model = data;
          }
        });
      }
    });

    //获取酒店星级字典数据
    const onLoadXj = () => {
      dic_getHotelRating().then((res) => {
        if (res.status == 200) state.xj_data = res.data.data;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            bankAccount_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            bankAccount_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadXj,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
